import React, { useState, useEffect } from "react";
import toastError from "../../errors/toastError";
import { parseISO, formatDistanceToNow } from "date-fns";

import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Skeleton from '@material-ui/lab/Skeleton';
import Tooltip from '@material-ui/core/Tooltip';

import { i18n } from "../../translate/i18n";
import api from "../../services/api";

import Title from "./Title";

const useStyles = makeStyles(theme => ({
	root: {
		'& > *': {
			marginTop: theme.spacing(0.5),
			marginBottom: theme.spacing(0.5),
			marginRight: theme.spacing(1),
		},
	},
}));

const Online = () => {
	const classes = useStyles();

	const [loading, setLoading] = useState(false);
	const [onlineUsers, setOnlineUsers] = useState([]);

	useEffect(() => {
		(async () => {
			setLoading(true);
			try {
				const { data } = await api.get("/onlineusers");
				setOnlineUsers(data.onlineUsers);

				setLoading(false);
			} catch (err) {
				toastError(err);
				setLoading(false);
			}
		})();
	}, []);

	return (
		<>
			<Title>{i18n.t("dashboard.onlineUsers.title")}</Title>
			<div className={classes.root}>
				{onlineUsers.map(online => (
					<Tooltip title={`${formatDistanceToNow(parseISO(online.lastVisit))} ago`} arrow>
						<Chip label={online.user.name} variant="outlined" />
					</Tooltip>
				))}
				{loading && <Skeleton animation="wave" variant="rect" width="30%" height={32} />}
			</div>
		</>
	);
};

export default Online;
